import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconFailure = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 85,
	height: 85,
	viewBox: "0 0 85 85",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M63.6706 21.4931C65.8836 23.7061 65.8836 27.294 63.6706 29.507L29.5071 63.6705C27.2941 65.8834 23.7062 65.8834 21.4932 63.6705C19.2803 61.4575 19.2803 57.8696 21.4932 55.6566L55.6567 21.4931C57.8697 19.2801 61.4576 19.2801 63.6706 21.4931Z",
		fill: "#FF707D"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M63.6703 63.6705C61.4574 65.8834 57.8694 65.8834 55.6565 63.6705L21.493 29.507C19.28 27.294 19.28 23.7061 21.493 21.4931C23.706 19.2801 27.2939 19.2801 29.5069 21.4931L63.6703 55.6566C65.8833 57.8696 65.8833 61.4575 63.6703 63.6705Z",
		fill: "#FF707D"
	})]
});
export default SvgIconFailure;
